<template>
    <tag
        :display="status.display"
        no-icon
        >
        <span class="inline-flex gap-5 items-center">
            <svg-icon v-if="loading" class="animate-spin w-18 h-18 mr-5" size="small" type="loader"/>
            {{ status.label }}
        </span>
    </tag>
</template>

<script>
import Campaign from "../models/Campaign";
import moment from 'moment';
import SvgIcon from "./ui/SvgIcon";
import Tag from "./ui/Tag.vue";

export default {
    components: {
        Tag,
        'svg-icon': SvgIcon,
    },
    props: {
        campaign: Campaign,
        small: Boolean,
        loading: Boolean,
    },
    computed: {
        paddingClass() {
            return this.small ? 'py-2 px-4' : 'py-4 px-8'
        },
        status() {
            for (const type in this.statusTypes) {
                if (type === "default" || (this.campaign[type] || null)) {
                    return this.statusTypes[type];
                }
            }
        }
    },
    created() {
        this.campaign.open = this.campaign.status === 'open';
    },
    data() {
        return {
            statusTypes: {
                "draft": {
                    display: 'info',
                    label: this.$t('campaigns.statuses.draft'),
                },
                "open": {
                    display: 'primary',
                    label: this.$t('campaigns.statuses.open'),
                },
                "processing": {
                    display: 'warning',
                    label: this.$t('campaigns.statuses.processing'),
                },
                "published": {
                    display: 'warning',
                    label: this.$t('general.scheduled_for_date', {date: moment(this.campaign.date_start).format('DD/MM/YYYY')}),
                },
                "online": {
                    display: 'success',
                    label: this.$t('campaigns.statuses.online'),
                },
                "default": {
                    display: 'warning',
                    label: this.$t('campaigns.statuses.unpublished'),
                },
            }
        }
    }
}
</script>
